__turbopack_context__.v({
  "inverted": "el_8cq_inverted",
  "teaser": "el_8cq_teaser",
  "teaserdisclaimer": "el_8cq_teaserdisclaimer",
  "teaserimage": "el_8cq_teaserimage",
  "teaserlinks": "el_8cq_teaserlinks",
  "teaserparagraph": "el_8cq_teaserparagraph",
  "teasertext": "el_8cq_teasertext",
});
